import { Form, Formik } from "formik";
import React, { useMemo } from "react";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { UPDATE_USER_RS } from "../../../api/apiAdmin";
import InputField from "../../atoms/InputField";
import Button from "../../atoms/Button";
import Select from "react-select";

const ModalEditUsuarioRS = ({ usuario, onClose, refetch, usuarios = [] }) => {
    const parentOptions = useMemo(() => {
        return usuarios
            .filter((u) => u.actualNode !== usuario.actualNode)
            .map((u) => ({
                value: u.actualNode,
                label: `${u.name} (Nodo: ${u.actualNode})`,
            }));
    }, [usuarios, usuario]);

    const validate = (values) => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!values.name) { errors.name = "El nombre es requerido"; }
        if (!values.email) { errors.email = "El email es requerido"; } 
            else if (!emailRegex.test(values.email)) { errors.email = "El email no es válido"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const upperCaseValues = {
                ...values,
                name: values.name.toUpperCase(),
            };
            await UPDATE_USER_RS(usuario.id , upperCaseValues);
            toast.success("Cambio exitoso");
            refetch();
            onClose();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = { 
        name: usuario.name || "", 
        cellphone: usuario.cellphone || "",
        email: usuario.email || "", 
        position: usuario.position || "",
        parentNode: usuario.parentNode || "",
        password: "", 
    };

    return(
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validate={validate}
            >
                {({ isSubmitting, setFieldValue, values }) => (
                    <Form className="w-full flex flex-col items-center justify-center text-center space-y-4">
                        <InputField name="name" label="Nombre completo" placeholder="Nombre completo" capitalize/>
                        <InputField name="cellphone" label="Teléfono" placeholder="Número de teléfono" capitalize type="number" />
                        <InputField name="email" label="Correo electrónico" placeholder="CORREO ELECTRÓNICO" />
                        <InputField name="position" label="Posición / Cargo" placeholder="Posición o cargo" capitalize />
                        <div className="w-full text-left">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                JEFE DIRECTO
                            </label>
                            <Select
                                name="parentNode"
                                options={parentOptions}
                                className="basic-select border border-black rounded-lg"
                                classNamePrefix="select"
                                placeholder="Seleccionar jefe directo..."
                                isClearable
                                onChange={(selectedOption) =>
                                    setFieldValue("parentNode", selectedOption ? selectedOption.value : "")
                                }
                                value={parentOptions.find((opt) => opt.value === values.parentNode) || null}
                            />
                        </div>
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Actualizar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                    </Form>
                )}
            </Formik>
        </div>
    )
};

export default ModalEditUsuarioRS;